import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import {
  DetailsDimensionsData,
  ReportComponentActionIntent,
  ReportDashboardComponentViewData,
  ReportDashboardMetricOptions,
  VisualizationActionsAvailability,
  VisualizationDataTypeUnion,
} from '@core/reports-types';
import { SortValue } from '@core/search-types';
import { ResizeObserverEntryDirective } from '@core/user-interface-legacy';

import { PresentionalFailedEmptyStateReason } from '../failed-empty-state/failed-empty-state.component';
import { VisualizationActionsComponent } from '../visualization-actions/visualization-actions.component';
import { VisualizationLayoutComponent } from '../visualization-layout/visualization-layout.component';
import { VisualizationLoadingIndicatorComponent } from '../visualization-loading-indicator/visualization-loading-indicator.component';
import { VisualizationRendererComponent } from '../visualization-renderer/visualization-renderer.component';
import { ReportsVisualizationTitleComponent } from '../visualization-title/visualization-title.component';

export type DashboardComponentMeta = {
  failed: boolean;
  loading: boolean;
  loaded: boolean;
};

@Component({
  selector: 'reports-visualization',
  styleUrls: ['./reports-visualization.component.less'],
  templateUrl: './reports-visualization.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    VisualizationLayoutComponent,
    ReportsVisualizationTitleComponent,
    VisualizationActionsComponent,
    VisualizationLoadingIndicatorComponent,
    VisualizationRendererComponent,
    ResizeObserverEntryDirective,
  ],
})
export class ReportsVisualizationComponent {
  public visData = input.required<VisualizationDataTypeUnion | null>();
  public component = input.required<ReportDashboardComponentViewData | null>();
  public metric = input.required<ReportDashboardMetricOptions | null>();
  public meta = input.required<DashboardComponentMeta>();
  public availableActions = input.required<VisualizationActionsAvailability>();
  public embeddedFilters = input.required<boolean>();

  public fullscreenAvailable = input<boolean>();
  public visualizationDisabled = input<PresentionalFailedEmptyStateReason | null>(null);

  public displayResizeHandlers = input<boolean>(true);
  public filtersOverflowHidden = input<boolean>(false);
  public showActions = input<boolean>(true);

  public openFeatureGuard = output();
  public handleAction = output<ReportComponentActionIntent>();
  public updateSort = output<SortValue>();
  public refresh = output();
  public openDetails = output<DetailsDimensionsData>();
  public editComponent = output();
}
